<template>
   <v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <h4>近日開催イベント</h4>
      <v-list two-line>
        <p v-if="items">現在予定されているイベントはございません。<br></p>
        <template v-for="item in items">

          <v-card :to="item.to" class="mb-3">
            <v-card-media
              class="white--text"
              v-bind:class="'colorfilter-' + item.category"
              height="200px"
              src="/static/carousel/1.JPG"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-center flexbox>
                    <div class="ah-tournament-card">
                      <span class="sub-title">{{item.startTime | dateformat}}</span>
                      <span class="title"><div v-html="item.title"></div></span>
                      <span class="sub-title">{{item.subTitle}}</span>
                    </div>

                    <span class="display-1">
                          </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-media>
          </v-card>

        </template>
      </v-list>

      <h4>終了済みイベント</h4>
      <v-list two-line>
        <template v-for="item in finishedTournaments">

          <v-card :to="item.to" class="mb-3">
            <v-card-media
              class="white--text"
              v-bind:class="'colorfilter-' + item.category"
              height="230px"
              src="/static/carousel/1.JPG"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-center flexbox>
                    <div class="ah-tournament-finished-card">
                      <span class="sub-title" style="background-color: red;display:table;">受付終了</span>
                      <span class="sub-title">{{item.startTime | dateformat}}</span>
                      <span class="title"><div v-html="item.title"></div></span>
                      <span class="sub-title">{{item.subTitle}}</span>
                    </div>

                    <span class="display-1">
                          </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-media>
          </v-card>

        </template>
      </v-list>
    </v-flex>
  </v-layout>
   </v-container>
</template>

<script>
  export default {
    data: () => ({
      date: null,
      menu: false,
      modal: null
    })
  }
</script>

<script>
import firebase from 'firebase'

export default {
  components: {
    firebase
  },
  data () {
    var user = firebase.auth().currentUser
    if (user) {
      // User is signed in.
      // displayName = (user.displayName)
      // photoURL = user.photoURL
      // email = user.email
    } else {
      // No user is signed in.
    }
    return {
      // items: [{ header: '所属チーム' }]
      items: [],
      finishedTournaments: [],
      colorfilter: 'colorfilter-purple'
    }
  },
  created () {
    // select teams
 //   var list = this.items
    var db = firebase.firestore()
    let query = db.collection('tournaments')
                      .where('endTime', '>', new Date())
                      .orderBy('endTime')

    query.get().then(querySnapshot => {
      querySnapshot.forEach(doc => {
        var obj = doc.data()
        obj.to = '/tournament/' + doc.id
        this.items.push(obj)
      })
    })
    // old
    let query2 = db.collection('tournaments')
      .where('endTime', '<', new Date())
      .orderBy('endTime', 'desc')

    query2.get().then(querySnapshot => {
      querySnapshot.forEach(doc => {
        var obj = doc.data()
        obj.to = '/tournament/' + doc.id
        this.finishedTournaments.push(obj)
      })
    })
  },
  methods: {
    update: function () {
      //
      // email = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tournament/TournamentSearch.vue